import { post } from '@/util/http'

/**
 * 分页获取模糊查询列表
 *
 * @param pager
 *            通用查询分页对象
 * @param fuzzyText
 *            模糊查询字符串
 * @return Result
 */
export const selectPageByFuzzyNotice = params => post(`/common/notice/selectPageByFuzzy`, params);
/**
 * 新增实体
 *
 * @param vo
 *            接收新增参数的VO对象
 * @return Result
 */
export const insertNotice = params => post(`/common/notice/insert`, params);
/**
 * 根据id更新实体, 全部字段覆盖更新
 *
 * @param vo
 *            接收更新参数的VO对象
 * @return Result
 */
export const updateAllColumnNotice = params => post(`/common/notice/updateAllColumn`, params);
/**
 * 根据id删除实体
 *
 * @param id
 *            删除该id的实体
 * @return Result
 */
export const deleteByIdNotice = params => post(`/common/notice/deleteById`, params);
/**
 * 根据id列表批量删除数据
 *
 * @param listParam
 *            ListParam.lsIds批量删除的id列表
 * @return Result
 */
export const deleteBatchIdsNotice = params => post(`/common/notice/deleteBatchIds`, params);
/**
 * 获取查询列表
 *
 * @param vo
 *            接收查询参数的VO对象
 * @return Result
 */
export const selectListNotice = params => post(`/common/notice/selectList`, params);
/**
 * 分页查询获取列表
 *
 * @param pager
 *            通用查询分页对象
 * @param vo
 *            接收查询参数的VO对象
 * @return Result
 */
export const selectPageNotice = params => post(`/common/notice/selectPage`, params);
/**
 * 根据id更新实体，仅更新非空字段
 *
 * @param vo
 *            接收更新参数的VO对象
 * @return Result
 */
export const updateNotice = params => post(`/common/notice/update`, params);
/**
 * 获取查询结果统计记录数
 *
 * @param vo
 *            接收查询参数的VO对象
 * @return Result
 */
export const selectCountNotice = params => post(`/common/notice/selectCount`, params);
